module.exports = __webpack_public_path__ + "img/1942-chinese-canadian-recruits-victoria.e83165e4.jpg";